// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5f471ce0","453":"7b792f26","455":"f0434c9a","977":"95c68488"}[chunkId] + ".chunk.js";
};